import axios from "axios";
import { toast } from "react-toastify";
import { Urls, mainUrl } from "../apiUrls/apiUrl";

export const PROJECT_API = {
  getProjects,
  getSiteEngineers,
  getProjectsByFilter,
  projectAllocationToSiteEngineer,
  getNCRlist,
  createUpdateNcr,
  getSOPList,
  getJobMethodologyList,
  saveDocument,
  insertUpdateJobMethodology,
  getCheckList,
  insertUpdateCheckList,
  getCheckListAdmin,
};

function handleError(error) {
  if (error.response) {
    const { status, data } = error.response;
    if (status === 401) {
      toast.error("Unauthorized Access!");
    } else if ([400, 404, 409, 500].includes(status)) {
      toast.error(data?.message || "An error occurred.");
    }
  } else {
    toast.error("An unexpected error occurred.");
  }
  return Promise.reject(error);
}

function getAuthToken() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return null;
  }
  return { token, state };
}

function getSiteEngineers() {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token, state } = auth;
  const requestData = { RoleID: 2 };

  return axios
    .post(`${mainUrl}api/User/GetSiteEngineer`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}

function getProjects() {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");
  const { token, state } = auth;
  const requestData = {
    EmailID: state?.user?.Email,
  };

  return axios
    .post(
      `${mainUrl}api/Projects/${
        state?.user?.Role === "Site Engineer "
          ? "GetProjectAllocationDetails"
          : "get_project"
      } `,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => response.data)
    .catch(handleError);
}

function getProjectsByFilter(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/Projects/GetProjectsDetailsByFilters`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function projectAllocationToSiteEngineer(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;
  return axios
    .post(`${mainUrl}api/Projects/ProjectAllocateToSiteEngineer`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}

function getNCRlist(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/Quality/GetQualityNCRDetails`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function createUpdateNcr(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/Quality/InsertUpdateQualityNCR`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function getSOPList() {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .get(`${mainUrl}api/Admin/Get_SafetyStandardSOP`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function getCheckListAdmin() {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .get(`${mainUrl}api/Admin/Get_QualityChecklist`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function getJobMethodologyList(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token, state } = auth;

  return axios
    .post(`${mainUrl}api/Quality/GetQualitySOPJobMethodologyDetails`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function saveDocument(file) {
  // debugger
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const formData = new FormData();
  formData.append("file", file);
  const { token } = auth;
  return axios
    .post(`${mainUrl}api/Upload/SaveDocument`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function insertUpdateJobMethodology(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token, state } = auth;

  return axios
    .post(
      `${mainUrl}api/Quality/InsertUpdateQualitySOPJobMethodology`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => response.data)
    .catch(handleError);
}
function getCheckList(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token, state } = auth;
  let obj = "";
  if (!payload) {
    obj = {
      UserID: state.user.user_id,
    };
  } else {
    obj = payload;
  }

  return axios
    .post(`${mainUrl}api/Quality/GetQualtiySOPCheckListDetails`, obj, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function insertUpdateCheckList(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token, state } = auth;

  return axios
    .post(`${mainUrl}api/Quality/InsertUpdateQualtiySOPCheckList`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
